import { Plus, Clock } from "lucide-react";
import { useState } from "react";

import { useAutomations } from "@/hooks/useAutomations";

import { AutomationCard } from "./AutomationCard";
import { AutomationModal } from "./AutomationModal";

export function AutomationList(): JSX.Element {
  const { data, isLoading } = useAutomations();
  const [showCreate, setShowCreate] = useState(false);

  const automations = data?.automations ?? [];

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      {/* Header */}
      <div className="flex-shrink-0 border-b border-cyber-border px-4 py-3">
        <div className="flex items-center justify-between px-6">
          <div className="flex items-center gap-2">
            <Clock size={16} className="text-cyber-cyan" />
            <h2 className="text-sm font-medium text-cyber-text">Automations</h2>
            {automations.length > 0 && (
              <span className="rounded-full bg-cyber-surface px-1.5 py-0.5 text-[10px] text-cyber-muted">
                {automations.filter((a) => a.status === "enabled").length} active
              </span>
            )}
          </div>
          <button
            onClick={() => setShowCreate(true)}
            className="flex items-center gap-1.5 rounded border border-cyber-cyan/30 px-3 py-1.5 text-xs text-cyber-cyan transition-all hover:bg-cyber-cyan/10"
          >
            <Plus size={14} />
            New automation
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4">
        <div className="mx-auto max-w-3xl space-y-2">
          {isLoading ? (
            <div className="py-8 text-center text-cyber-muted">
              <span className="animate-spin-glow mr-2 inline-block">◐</span>
              Loading automations...
            </div>
          ) : automations.length === 0 ? (
            <div className="py-16 text-center">
              <Clock size={32} className="mx-auto mb-3 text-cyber-muted/30" />
              <p className="mb-1 text-sm text-cyber-muted">No automations yet</p>
              <p className="text-xs text-cyber-muted/60">
                Create one to run scheduled investigations.
              </p>
              <button
                onClick={() => setShowCreate(true)}
                className="mt-4 rounded border border-cyber-cyan/30 px-4 py-2 text-xs text-cyber-cyan transition-all hover:bg-cyber-cyan/10"
              >
                Create your first automation
              </button>
            </div>
          ) : (
            automations.map((automation) => (
              <AutomationCard key={automation.id} automation={automation} />
            ))
          )}
        </div>
      </div>

      {showCreate && <AutomationModal onClose={() => setShowCreate(false)} />}
    </div>
  );
}
